<script lang="ts" setup>
// One label and its value in a transaction row. The parent supplies `<dl class="row mb-0 small">`, so the label
// sits beside its value from the sm breakpoint and above it on a phone.
defineProps<{ label: string }>();
</script>

<template>
  <dt class="col-sm-3 fw-normal text-body-secondary">{{ label }}</dt>
  <dd class="transaction-field-value col-sm-9 mb-2 min-w-0"><slot /></dd>
</template>

<style scoped>
/* A URL or a header value has no spaces to break at, so it may break anywhere rather than widen the panel. */
.transaction-field-value {
  overflow-wrap: anywhere;
}
</style>
